import styled from 'styled-components';

export const TotalSelectedStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border-color-light);
  background-color: var(--bg-gray);
  border-radius: 5px;
  margin-bottom: 13px;
  padding: 10px 15px;
`;

export const ProductTableStyle = styled.div`
  .row-table-selection {
    display: none;
  }
`;
